<script>
    export default {
        name: "ProductPrice",
        props: {
            oldPrice: Number,
            price: Number,
            discountCount: Number,
            isSmallSize: Boolean,
            isMediumSize: Boolean,
            isCardSize: Boolean,
            isHeaderSize: Boolean,
        },
        computed: {
            isDiscount() {
                return this.discountCount;
            },
        },
    };
</script>

<template>
    <div
        class="product-price"
        :class="{
            'product-price--sm': isSmallSize,
            'product-price--md': isMediumSize,
            'product-price--card': isCardSize,
            'product-price--header': isHeaderSize,
        }"
    >
        <div class="product-price__wrap">
            <div
                class="product-price__number product-price__number--current"
                :class="{
                    'product-price__number--discount': isDiscount,
                }"
            >
                {{ price | formatPrice }}₽
            </div>
            <div v-if="isDiscount" class="product-price__number product-price__number--old">
                {{ oldPrice | formatPrice }}₽
            </div>
        </div>
        <div v-if="isDiscount" class="product-price__label">-{{ discountCount }}%</div>
    </div>
</template>

<style lang="scss">
    .product-price {
        position: relative;
        display: flex;
        align-items: flex-end;
    }

    .product-price__label {
        width: 52px;
        height: 24px;
        color: #fff;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        border-radius: 4px;
        background: var(--danger);
        text-align: center;
        @include bp($bp-desktop-sm) {
            font-size: 16px;
            line-height: 24px;
        }
    }

    .product-price__wrap {
        display: flex;
        align-items: baseline;
    }

    .product-price__number {
        color: var(--primary-text);
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 20px;
        }
    }

    //
    // --mod
    //

    .product-price__number--current {
        margin-right: 8px;
    }

    .product-price__number--discount {
        color: var(--danger-text);
    }

    .product-price__number--old {
        margin-right: 12px;
        font-weight: 500;
        font-size: 14px;
        color: var(--primary-text);
        text-decoration: line-through;

        @include bp($bp-desktop-sm) {
            font-size: 16px;
        }
    }

    .product-price--sm {
        .product-price__wrap {
            flex-direction: column-reverse;
        }

        .product-price__number {
            font-size: 14px;
            line-height: 16px;
            @include bp($bp-desktop-sm) {
                font-size: 18px;
                line-height: 20px;
            }
        }

        .product-price__number--old {
            font-size: 10px;
            line-height: 16px;
            @include bp($bp-desktop-sm) {
                font-size: 14px;
            }
        }

        .product-price__label {
            font-size: 12px;
            width: 38px;
            height: 18px;
            line-height: 18px;
            @include bp($bp-desktop-sm) {
                font-size: 12px;
                width: 38px;
                height: 18px;
                line-height: 18px;
            }
        }
    }

    .product-price--md {
        .product-price__number {
            font-size: 18px;
            line-height: 26px;
            @include bp($bp-desktop-sm) {
                font-size: 32px;
            }
        }

        .product-price__number--old {
            font-size: 14px;
            line-height: 26px;
            @include bp($bp-desktop-sm) {
                font-size: 16px;
            }
        }

        .product-price__label {
            font-size: 14px;
            @include bp($bp-desktop-sm) {
                font-size: 16px;
            }
        }
    }

    .product-price--card:not(.product-price--sm) {
        .product-price__wrap {
            flex-direction: column-reverse;
        }

        .product-price__number {
            font-size: 18px;
            line-height: 22px;

            @include bp($bp-desktop-sm) {
                font-size: 24px;
                line-height: 28px;
            }
        }

        .product-price__number--old {
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 4px;

            @include bp($bp-desktop-sm) {
                font-size: 16px;
                line-height: 20px;
            }
        }

        .product-price__label {
            width: 44px;
            font-size: 14px;
            line-height: 22px;
            height: 22px;

            @include bp($bp-desktop-sm) {
                width: 52px;
                height: 28px;
                font-size: 16px;
                line-height: 28px;
            }
        }
    }

    .product-price--header {
        .product-price__number {
            font-size: 14px;
            line-height: 18px;
        }
        .product-price__number--old {
            font-size: 12px;
        }
        .product-price__label {
            width: 38px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
        }
    }
</style>
